<script>
  import { location, replace } from "svelte-spa-router";
  import ObjectDisplay from "../components/ObjectDisplay.svelte";
  import TopicNavigation from "../components/TopicNavigation.svelte";
  import {
    letterData,
    languages,
    selectedLanguage1,
    selectedLanguage2,
    letters,
    userLoggedIn,
    route,
    topicData,
    loadingData,
  } from "../services/store";
  import Icon from "fa-svelte";
  import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
  import { _ } from "svelte-i18n";
  let subTopic,
    language1,
    language2,
    commonImg,
    data1,
    data2,
    selectedLink,
    backLetter,
    mainTopic,
    topicList,
    unique = {},
    displayAdditionalNavbar;

  $: if ($route.indexOf("/letters") > -1) {
    handleLetterChange("letters");
  }
  $: if ($route.indexOf("/nature") > -1) {
    handleLetterChange("nature");
  }
  $: if ($route.indexOf("/culture") > -1) {
    handleLetterChange("culture");
  }
  $: if ($route.indexOf("/world") > -1) {
    handleLetterChange("world");
  }
  $: if (!$loadingData) {
    handleLetterChange();
  }
  $: if (
    $selectedLanguage1 &&
    $selectedLanguage2 &&
    language2 === null &&
    language1 === null
  ) {
    handleLetterChange();
  }
  $: if (!$selectedLanguage1 || !$selectedLanguage2) {
    reset(true);
  }

  function handleLetterChange(link) {
    if (!$userLoggedIn) {
      replace("/login");
    }
    if (link) {
      selectedLink = link;
    }
    if (
      $letterData &&
      $selectedLanguage1 &&
      $selectedLanguage2 &&
      $letters &&
      $languages
    ) {
      handleDataExists();
    } else {
      reset();
    }
  }
  function handleDataExists() {
    language1 = $languages.find(
      (lan) =>
        $selectedLanguage1 == lan.value || $selectedLanguage1.value == lan.value
    );
    language2 = $languages.find(
      (lan) =>
        $selectedLanguage2 == lan.value || $selectedLanguage2.value == lan.value
    );

    let dataToUse;
    unique = {};
    if (!selectedLink) {
      selectedLink = "letters";
    }
    switch (selectedLink) {
      case "letters":
        displayAdditionalNavbar = false;
        let urlLetter = $location.split("/" + selectedLink + "/")[1];
        subTopic = $letters.find((l) => l.value === urlLetter);
        dataToUse = $letterData;
        break;
      case "nature":
      case "culture":
      case "world":
        displayAdditionalNavbar = true;
        dataToUse = null;
        let splits = $location.split("/");
        // first is empty, second is link, third is topic, fourth subtopic, fifth eventually backlink
        if (splits && splits.length >= 3) {
          if (splits.length >= 5) {
            // with backlink
            backLetter = $letters.find((l) => l.value === splits[4]);
          }
          if (splits.length >= 4) {
            // maybe with backlink
            mainTopic = splits[2];
            subTopic = splits[3];
            subTopic = { value: subTopic, display: subTopic };
            dataToUse = $topicData[selectedLink];
          }
          if (splits.length === 3) {
            mainTopic = splits[2];
          }
        } else {
          mainTopic = null;
        }
        break;

      default:
        break;
    }

    if (subTopic && subTopic.value && dataToUse) {
      if (language1 && language2) {
        if (displayAdditionalNavbar) {
          handleOtherData(dataToUse, subTopic.value, language1, language2);
        } else {
          handleLetterData(dataToUse, subTopic.value, language1, language2);
        }
      }
    } else {
      redirectToFirstOfTarget();
    }
  }
  function handleLetterData(dataToUse, subTopic, language1, language2) {
    commonImg = null;
    data1 = dataToUse.find((l) => l.language === language1.value).data;
    data2 = dataToUse.find((l) => l.language === language2.value).data;
    if (data1 && data2 && data1[subTopic] && data2[subTopic]) {
      // set links
      if (data1[subTopic].link && !data2[subTopic].link) {
        data2[subTopic].link = data1[subTopic].link;
      } else if (data2[subTopic].link && !data1[subTopic].link) {
        data1[subTopic].link = data2[subTopic].link;
      }
      //set img
      if (data1[subTopic].img === data2[subTopic].img) {
        commonImg = data1[subTopic].img;
      }
    }
  }
  function handleOtherData(dataToUse, subTopic, language1, language2) {
    data1 = dataToUse.find((l) => {
      return l.language === language1.value && l.subtopic === mainTopic;
    });
    data2 = dataToUse.find((l) => {
      return l.language === language2.value && l.subtopic === mainTopic;
    });
    if (data1 && data2 && data1.data && data2.data) {
      data1 = data1.data;
      data2 = data2.data;
      topicList = Object.keys(data1);
      if (data1[subTopic].img === data2[subTopic].img) {
        commonImg = data1[subTopic].img;
      } else {
        commonImg = null;
      }
    }
  }

  function reset(alsoLanguages) {
    data1 = null;
    data2 = null;
    commonImg = null;
    if (alsoLanguages) {
      language1 = null;
      language2 = null;
    }
  }

  function redirectToFirstOfTarget() {
    reset();
    if (selectedLink === "letters") {
      replace(`/${selectedLink}/a`);
    } else {
      if ($topicData[selectedLink][0].data) {
        let keys;
        if (mainTopic) {
          keys = $topicData[selectedLink].find((t) => t.subtopic === mainTopic);
          let finding = Object.keys(keys.data)[0];
          replace(`/${selectedLink}/${mainTopic}/${finding}`);
        } else {
          keys = Object.keys($topicData[selectedLink][0].data);
          replace(
            `/${selectedLink}/${$topicData[selectedLink][0].subtopic}/${keys[0]}`
          );
        }
      }
    }
  }
  function onBackClick() {
    replace("/letters/" + backLetter.value);
  }
</script>

<section
  class="relative  bg-gradient-to-r {displayAdditionalNavbar
    ? `from-gradient_${selectedLink}1 to-gradient_${selectedLink}2`
    : 'py-16'}"
>
  {#if displayAdditionalNavbar}
    <TopicNavigation {selectedLink} {subTopic} list={topicList} {mainTopic} />
    {#if backLetter}
      <button
        class=" mt-4   ml-2   p-2
    transition duration-500 ease-in-out uppercase
  text-gray-600  bg-primary-300 border rounded-full transform 
   hover:bg-accent-100 hover:-translate-y-1 hover:scale-110
   focus:bg-accent-100 focus:-translate-y-1 focus:scale-110"
        on:click={onBackClick}
      >
        <Icon icon={faArrowLeft} />
        {backLetter.display
          ? $_("letterDisplay.backToLetter") + backLetter.display
          : $_("letterDisplay.backToAllLetter")}
      </button>
    {/if}
  {/if}

  {#key unique}
    <ObjectDisplay
      {selectedLink}
      {commonImg}
      {data1}
      {data2}
      {language1}
      {language2}
      {subTopic}
    />
  {/key}
</section>
